<script lang="ts">
export type BadgeColor = "grey" | "green" | "red" | "blue";
export type BadgeSize = "l" | "m" | "s";
export type BadgeProps = {
  color: BadgeColor;
  leftIcon?: string;
  rightIcon?: string;
  size?: BadgeSize;
};
</script>

<script setup lang="ts">
const { color, leftIcon, rightIcon, size = "m" } = defineProps<BadgeProps>();
</script>

<template>
  <div class="color-badge text-base-medium" :class="[color, size]">
    <div>
      <i v-if="leftIcon" :class="leftIcon" class="icon left" />
    </div>

    <div>
      <slot></slot>
    </div>

    <div>
      <i v-if="rightIcon" :class="rightIcon" class="icon right" />
    </div>
  </div>
</template>

<style scoped>
.color-badge {
  display: inline-flex;
  align-items: flex-start;
  border-radius: var(--numbers-12);

  &.s {
    padding: var(--numbers-4) var(--numbers-6);
  }

  &.m {
    padding: var(--numbers-6) var(--numbers-8);
  }

  &.l {
    padding: var(--numbers-12);
  }

  &.grey {
    background-color: var(--background-tertiary);
    color: var(--content-primary);
  }

  &.green {
    background-color: var(--background-positive-subtle);
    color: var(--content-positive);
  }

  &.red {
    background-color: var(--background-negative-subtle);
    color: var(--content-negative);
  }

  &.blue {
    background-color: var(--background-info-subtle);
    color: var(--content-info);
  }

  .icon {
    font-size: 1.1rem;
    vertical-align: middle;

    &.left {
      margin-right: var(--numbers-6);
    }

    &.right {
      margin-left: var(--numbers-6);
    }
  }
}
</style>
